"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = getUploadProgress;

function getBytes(a) {
  return Number.isNaN(+a) ? "0" : (0, _getDisplayBytes["default"])(a);
}

function getUploadProgress(a, b, c) {
  return 100 === c ? "Complete" : 99 === c ? "Finalising" : "".concat(getBytes(a), " / ").concat(getBytes(b));
}